<template>
    <div class="vue-google-inside-wrapper" v-if="hasUrl && open" :class="{'open': open }">
        <iframe :src="url" style="border:0;" allowfullscreen="" loading="lazy"></iframe>

        <button @click="handleClose" class="btn-close"></button>
    </div>
</template>

<script>
export default {
    name: "GoogleInsideWrapper",

    props: ['eventBus'],

    data() {
        return {
            open: false,
            url: '',
        }
    },

    computed: {
        hasUrl() {
            return ! _.isEmpty(this.url);
        }
    },

    mounted() {
        this.eventBus.$on('open-360-wrapper', (payload) => this.handleOpen360Wrapper(payload));
    },

    methods: {
        handleOpen360Wrapper(payload) {
            this.url = payload;
            this.open = true;
        },

        handleClose() {
            this.url = '';
            this.open = false;
        }
    }
}
</script>